import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const WeatherNoticeIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M11 4C12.6403 4 14.075 4.8781 14.8613 6.18945C15.2183 6.0667 15.6014 6 16 6C17.8206 6 19.3146 7.39028 19.4824 9.16699C20.6564 9.57404 21.5 10.6875 21.5 12C21.5 13.6081 20.2348 14.9202 18.6455 14.9961L16.1221 10.6367C15.4799 9.52896 13.908 9.49214 13.207 10.5332L13.1416 10.6367L10.6162 15H6.5C4.29086 15 2.5 13.2091 2.5 11C2.5 8.79086 4.29086 7 6.5 7C6.58528 7 6.66995 7.00255 6.75391 7.00781C7.3695 5.25604 9.03782 4 11 4Z'
                fill='currentColor'
            />
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M14.1995 11.249C14.3921 10.917 14.8721 10.917 15.0647 11.249L19.6966 19.249C19.8895 19.5822 19.6488 19.9997 19.264 20H10.0013L9.93095 19.9951C9.58761 19.9484 9.3867 19.5616 9.56767 19.249L14.1995 11.249ZM14.6321 17.501C14.4906 17.501 14.3714 17.5488 14.2757 17.6445L14.2132 17.7207C14.1595 17.801 14.1322 17.8941 14.1321 18C14.1321 18.1414 14.1801 18.2607 14.2757 18.3564C14.3476 18.4283 14.4329 18.4733 14.5306 18.4912L14.6321 18.5C14.7383 18.5 14.832 18.4737 14.9124 18.4199L14.9876 18.3564C15.0834 18.2607 15.1321 18.1416 15.1321 18C15.132 17.8586 15.0833 17.7402 14.9876 17.6445L14.9124 17.5811C14.8587 17.5451 14.7989 17.5217 14.7337 17.5098L14.6321 17.501ZM14.6321 14.501C14.3562 14.5011 14.1322 14.725 14.1321 15.001V16.501L14.1429 16.6016C14.1895 16.8292 14.3907 17.0009 14.6321 17.001C14.8736 17.001 15.0747 16.8293 15.1214 16.6016L15.1321 16.501V15.001C15.1321 14.725 14.9081 14.501 14.6321 14.501Z'
                fill='currentColor'
            />
        </>
    ),
})

WeatherNoticeIcon.displayName = 'WeatherNoticeIcon'
